import axiosInstance from './axiosCreator';
import { cacheVignetteImages } from '../utils/imgCaching';
import { setTokens } from '../slices/auth/authSlice';
import { store } from '../store/store';

export const initDemoUser = async (demoUserId: string) => {
  try {
    const response = await axiosInstance.get(`/demo/init/${demoUserId}`);
    if (!response.data.success || !response.data.data) {
      console.error('Failed to init demo user:', response.data.error);
      return undefined;
    }
    store.dispatch(
      setTokens({
        authToken: response.data.data.authToken,
        refreshToken: response.data.data.refreshToken,
        userId: response.data.data.userId,
        isAuthenticated: false,
      })
    );
    return response.data.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchDemoStudySession = async (demoUserId: string) => {
  try {
    const response = await axiosInstance.get(`/demo/session/${demoUserId}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchDemoBlocksByStudySessionId = async (sessionId: string) => {
  try {
    const response = await axiosInstance.get(
      `/demo/session/${sessionId}/blocks`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchDemoVignettes = async () => {
  try {
    const response = await axiosInstance.get('/demo/vignettes');
    if (response.data && response.data.length > 0) {
      cacheVignetteImages(response.data);
    }
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const transferDemoProgress = async (
  demoUserId: string,
  completedDemoTour: boolean
) => {
  try {
    const response = await axiosInstance.post('/demo/transferProgress', {
      demoUserId,
      completedDemoTour,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
